import React from 'react'

export default function About() {
    return (
        <>
            <div className='h-screen overflow-hidden relative'>
                <img className='object-cover absolute' src="about-top.jpeg" alt="" />
                <div className='h-[55%] w-full bg-white absolute bottom-[0%]'></div>
                <div className='h-[50%] w-[70%] bg-white absolute shadow-xl top-[28%] left-[15%]'>
                    <h1 className='text-4xl m-[4%] mb-[2%] font-medium text-[#03236F]'>About Jobbwork</h1>
                    <p className='m-[5%] mt-[2%] font-medium text-xl text-[#03236F] text-start'>Jobbwork empowers businesses to collaborate effortlessly, seamlessly, and with lasting impact. Our platform bridges the gap between businesses, simplifying the process of outsourcing tasks and acquiring specialized expertise. <br />
                       <br /> Jobbwork cultivates a thriving ecosystem that fosters collaboration, networking, and enduring partnerships, eliminating the isolation often experienced in business endeavors. Embark on a journey with us to a business world where simplicity, efficiency, and interconnectedness reign supreme.
                    </p>
                </div>
            </div>
            <div className='h-screen'></div>
            <div className='h-screen'></div>
            <div className='h-screen'></div></>
    )
}
